'use client';

import React from 'react';

import { HeroSection } from '@/components/site/HeroSection';
import { SearchBookingBar } from '@/components/site/SearchBookingBar';
import { ValueProposition } from '@/components/site/ValueProposition';
import { PopularVehicles } from '@/components/site/PopularVehicles';
import { PromotionalBanner } from '@/components/site/PromotionalBanner';
import { NewsletterSection } from '@/components/site/NewsletterSection';
import { TestimonialsSection } from '@/components/site/TestimonialsSection';
import { sectionEnabled } from '@/lib/storefront/designs';
import { featuredVehicles, type HomeDesignProps } from './home-props';

/** The original home page: cinematic hero, search bar, selling points, promo. */
export function ClassicHome({
  vehicles,
  favorites,
  storefront,
  appearance,
  onToggleFavorite,
  onBookVehicle,
  onBookAny,
  onViewAll,
  onViewDetails,
  onSearch,
}: HomeDesignProps) {
  return (
    <>
      <HeroSection
        onBookRide={onBookAny}
        headline={storefront?.hero.headline || undefined}
        description={storefront?.hero.description || undefined}
        ctaLabel={storefront?.hero.ctaLabel || undefined}
        imageUrl={storefront?.hero.imageUrl || undefined}
        layout={appearance.heroLayout}
      />

      {sectionEnabled(appearance, 'search') && <SearchBookingBar onSearch={onSearch} />}

      {sectionEnabled(appearance, 'stats') && <ValueProposition />}

      {sectionEnabled(appearance, 'inventory') && (
        <PopularVehicles
          vehicles={featuredVehicles(vehicles, storefront)}
          favorites={favorites}
          onToggleFavorite={onToggleFavorite}
          onBookCar={onBookVehicle}
          onViewAll={onViewAll}
          onViewDetails={onViewDetails}
        />
      )}

      {sectionEnabled(appearance, 'promo') && <PromotionalBanner onClaimDiscount={onBookAny} />}

      {sectionEnabled(appearance, 'testimonials') && (
        <TestimonialsSection testimonials={storefront?.testimonials ?? []} />
      )}

      {sectionEnabled(appearance, 'newsletter') && <NewsletterSection />}
    </>
  );
}
